var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnfettiMobil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 715,
    viewBox: "0 0 375 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6802_56151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.411 58.234L365.277 55.5959L374.151 74.6166L384.411 58.234Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.328 27.035L333.986 18.963L333.79 35.0448L346.328 27.035Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.457 174.697L197.242 166.608L197.029 182.563L209.457 174.697Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.614 215.667L368.452 217.026L377.458 228.261L381.614 215.667Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.878 112.843L283.234 107.925L287.451 124.069L297.878 112.843Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.824 100.73L151.197 95.9391L155.397 111.955L165.824 100.73Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25 37.6163L155.679 34.0999L158.668 45.8743L166.25 37.6163Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.279 55.7615L378.326 43.6339L376.049 64.5241L393.279 55.7615Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.352 67.1873L249.271 55.0766L247.121 75.9499L264.352 67.1873Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.026 77.8465L97.3578 93.3803L118.282 94.8741L109.026 77.8465Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.53 146.463C322.22 146.902 319.192 144.585 318.753 141.277C318.314 137.969 320.632 134.942 323.942 134.502C327.251 134.063 330.279 136.38 330.719 139.688C331.285 142.979 328.84 146.023 325.53 146.463Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.063 83.861C241.753 84.3006 238.725 81.9836 238.286 78.6754C237.847 75.3672 240.165 72.3402 243.475 71.9006C246.784 71.4611 249.812 73.778 250.252 77.0862C250.818 80.3775 248.5 83.4045 245.063 83.861Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.332 139.623L199.575 138.329L204.109 148.086L209.332 139.623Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.876 123.821L183.633 119.73L183.552 127.898L189.876 123.821Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.306 154.713L218.965 151.68L221.624 161.945L228.306 154.713Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.234 167.492L157.777 164.986L159.91 173.249L165.234 167.492Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.831 138.379L206.155 132.277L205.105 142.904L213.831 138.379Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.157 144.252L140.592 138.006L139.415 148.65L148.157 144.252Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.439 143.305C225.784 143.525 224.198 142.311 223.978 140.657C223.758 139.003 224.973 137.418 226.627 137.198C228.282 136.978 229.868 138.192 230.088 139.846C230.435 141.483 229.221 143.069 227.439 143.305Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.302 184.659C177.647 184.879 176.061 183.665 175.841 182.011C175.622 180.357 176.836 178.771 178.491 178.551C180.146 178.332 181.732 179.545 181.951 181.199C182.298 182.836 181.084 184.422 179.302 184.659Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.394 152.669C136.739 152.889 135.153 151.676 134.934 150.021C134.714 148.367 135.928 146.782 137.583 146.562C139.238 146.342 140.824 147.556 141.044 149.21C141.28 150.991 140.049 152.45 138.394 152.669Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.278 187.2C190.968 187.64 187.94 185.323 187.501 182.015C187.061 178.706 189.379 175.679 192.689 175.24C195.999 174.8 199.027 177.117 199.466 180.425C199.905 183.734 197.587 186.761 194.278 187.2Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.398 113.958C135.234 114.245 133.215 112.701 132.928 110.537C132.641 108.374 134.186 106.356 136.35 106.069C138.514 105.782 140.533 107.326 140.82 109.489C140.997 111.796 139.562 113.67 137.398 113.958Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.128 49.8796C179.964 50.167 177.945 48.6224 177.658 46.4594C177.371 44.2963 178.916 42.2783 181.08 41.9909C183.244 41.7035 185.263 43.2481 185.55 45.4112C185.854 47.7015 184.292 49.5922 182.128 49.8796Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9938 52.4128C87.8298 52.7002 85.8111 51.1556 85.5239 48.9926C85.2366 46.8295 86.7821 44.8115 88.9461 44.5241C91.11 44.2367 93.1287 45.7813 93.416 47.9444C93.576 50.1243 92.0305 52.1423 89.9938 52.4128Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.985 32.501C311.076 32.7546 309.218 31.4476 308.948 29.4117C308.694 27.5032 310.002 25.6462 312.039 25.3757C313.948 25.1221 315.806 26.4292 316.076 28.465C316.347 30.5008 314.895 32.2474 312.985 32.501Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.107 83.8481C363.089 83.9833 362.079 83.211 361.944 82.1931C361.809 81.1752 362.582 80.1662 363.6 80.0309C364.619 79.8957 365.628 80.668 365.763 81.6859C365.898 82.7038 365.125 83.7128 364.107 83.8481Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.481 185.557C251.463 185.692 250.453 184.92 250.318 183.902C250.183 182.884 250.956 181.875 251.974 181.74C252.992 181.605 254.002 182.377 254.137 183.395C254.272 184.413 253.499 185.422 252.481 185.557Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.217 95.8833C322.198 96.0186 321.333 95.3566 321.198 94.3387C321.063 93.3208 321.725 92.4559 322.744 92.3207C323.762 92.1854 324.627 92.8474 324.762 93.8653C324.897 94.8832 324.108 95.765 323.217 95.8833Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.399 47.8376C277.872 48.0405 276.43 46.9371 276.227 45.4103C276.024 43.8834 277.128 42.442 278.656 42.2391C280.183 42.0362 281.625 43.1396 281.828 44.6664C282.031 46.1933 280.927 47.6347 279.399 47.8376Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.902 100.842C205.884 100.977 204.875 100.205 204.739 99.1872C204.604 98.1693 205.377 97.1603 206.395 97.0251C207.414 96.8898 208.423 97.6622 208.558 98.6801C208.693 99.698 207.921 100.707 206.902 100.842Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.013 196.717C339.613 196.903 338.188 195.927 337.985 194.4C337.799 193 338.776 191.575 340.303 191.373C341.704 191.187 343.129 192.163 343.331 193.69C343.534 195.216 342.541 196.514 341.013 196.717Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.746 130.41C353.601 130.563 352.591 129.79 352.439 128.645C352.287 127.5 353.06 126.491 354.206 126.339C355.351 126.187 356.361 126.959 356.513 128.104C356.665 129.249 355.892 130.258 354.746 130.41Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.894 94.4235C189.366 94.6264 187.924 93.5231 187.721 91.9962C187.519 90.4694 188.623 89.0279 190.15 88.8251C191.678 88.6222 193.12 89.7255 193.322 91.2524C193.542 92.9064 192.421 94.2207 190.894 94.4235Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.137 61.6835C212.737 61.8695 211.439 60.8765 211.253 59.4769C211.068 58.0772 212.061 56.7799 213.461 56.594C214.862 56.408 216.159 57.401 216.345 58.8006C216.404 60.2171 215.538 61.4975 214.137 61.6835Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.873 35.1723C291.855 35.3075 290.845 34.5352 290.71 33.5173C290.575 32.4994 291.348 31.4904 292.366 31.3552C293.384 31.2199 294.394 31.9922 294.529 33.0101C294.664 34.028 293.891 35.037 292.873 35.1723Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.734 66.2284C302.334 66.4144 301.036 65.4214 300.85 64.0218C300.664 62.6222 301.658 61.3249 303.058 61.1389C304.458 60.9529 305.756 61.9459 305.942 63.3455C306.128 64.7452 305.134 66.0425 303.734 66.2284Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14 64.0854C346.485 64.3052 344.899 63.0916 344.679 61.4375C344.46 59.7834 345.674 58.1978 347.329 57.978C348.984 57.7582 350.57 58.9719 350.789 60.626C351.009 62.2801 349.795 63.8657 348.14 64.0854Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.884 176.29C297.12 176.391 296.399 175.84 296.298 175.076C296.197 174.313 296.749 173.592 297.512 173.491C298.276 173.389 298.997 173.941 299.098 174.704C299.2 175.468 298.648 176.188 297.884 176.29Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.723 142.738C268.322 142.924 267.025 141.931 266.839 140.532C266.653 139.132 267.646 137.835 269.047 137.649C270.447 137.463 271.745 138.456 271.93 139.855C272.116 141.255 271.123 142.552 269.723 142.738Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.613 201.174C144.34 201.343 143.187 200.46 143.018 199.188C142.849 197.916 143.732 196.762 145.005 196.593C146.278 196.424 147.431 197.307 147.6 198.579C147.769 199.852 146.886 201.005 145.613 201.174Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3421 168.089C96.3054 168.359 94.5582 166.908 94.3047 165C94.0344 162.964 95.4864 161.217 97.3958 160.964C99.4325 160.693 101.18 162.144 101.433 164.053C101.687 165.961 100.252 167.835 98.3421 168.089Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6682 112.851C69.1406 113.054 67.6987 111.951 67.4959 110.424C67.2931 108.897 68.3971 107.456 69.9246 107.253C71.4521 107.05 72.894 108.153 73.0968 109.68C73.2996 111.207 72.1957 112.648 70.6682 112.851Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.443 208.604L358.084 200.404L357.888 216.486L370.443 208.604Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.267 352.295L217.843 349.031L223.342 364.097L232.267 352.295Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.508 356.11L308.218 357.487L317.351 368.704L321.508 356.11Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.268 185.651L302.128 175.078L297.326 188.664L310.268 185.651Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.818 211.1L137.681 213.621L147.747 224.067L150.818 211.1Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.982 297.261L311.212 286.391L307.528 302.548L321.982 297.261Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.348 219.058L179.777 215.541L182.765 227.316L190.348 219.058Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.449 248.629L273.369 236.518L271.219 257.391L288.449 248.629Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.628 327.904C346.318 328.344 343.29 326.027 342.851 322.718C342.411 319.41 344.73 316.383 348.039 315.944C351.349 315.504 354.377 317.821 354.816 321.129C355.383 324.42 352.937 327.464 349.628 327.904Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.161 265.302C265.851 265.742 262.823 263.425 262.384 260.117C261.944 256.809 264.263 253.782 267.572 253.342C270.882 252.902 273.91 255.219 274.349 258.528C274.916 261.819 272.598 264.846 269.161 265.302Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.973 305.263L207.73 301.172L207.649 309.34L213.973 305.263Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.404 336.154L243.063 333.122L245.722 343.386L252.404 336.154Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.536 324.745C249.881 324.965 248.295 323.751 248.076 322.097C247.856 320.443 249.07 318.857 250.725 318.637C252.38 318.418 253.966 319.631 254.186 321.285C254.533 322.922 253.318 324.508 251.536 324.745Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.49 369.391C219.587 370.942 215.82 369.888 214.252 366.86C212.701 363.958 213.755 360.193 216.658 358.642C219.561 357.091 223.328 358.144 224.88 361.046C226.448 364.075 225.393 367.84 222.49 369.391Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.496 295.399C159.332 295.687 157.313 294.142 157.026 291.979C156.738 289.816 158.284 287.798 160.448 287.51C162.612 287.223 164.631 288.768 164.918 290.931C165.095 293.238 163.66 295.112 161.496 295.399Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.226 231.321C204.062 231.608 202.043 230.064 201.756 227.901C201.468 225.738 203.014 223.72 205.178 223.432C207.342 223.145 209.361 224.69 209.648 226.853C209.935 229.016 208.39 231.034 206.226 231.321Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.957 240.487C105.793 240.774 103.775 239.23 103.488 237.067C103.2 234.904 104.746 232.886 106.91 232.598C109.074 232.311 111.092 233.856 111.38 236.019C111.667 238.182 109.994 240.217 107.957 240.487Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.083 213.942C335.174 214.196 333.316 212.889 333.046 210.853C332.775 208.817 334.1 207.088 336.137 206.817C338.046 206.564 339.904 207.871 340.174 209.906C340.444 211.942 338.992 213.689 337.083 213.942Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.579 366.997C275.56 367.132 274.551 366.359 274.416 365.342C274.281 364.324 275.053 363.315 276.072 363.179C277.09 363.044 278.099 363.816 278.235 364.834C278.37 365.852 277.597 366.861 276.579 366.997Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.166 195.041C253.765 195.227 252.468 194.234 252.282 192.834C252.096 191.435 253.089 190.137 254.49 189.951C255.89 189.765 257.188 190.758 257.373 192.158C257.559 193.558 256.566 194.855 255.166 195.041Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.314 277.325C346.296 277.46 345.431 276.798 345.296 275.78C345.161 274.762 345.823 273.897 346.841 273.762C347.86 273.627 348.725 274.289 348.86 275.307C348.995 276.325 348.206 277.206 347.314 277.325Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.497 229.279C301.969 229.482 300.527 228.379 300.325 226.852C300.122 225.325 301.226 223.883 302.753 223.681C304.281 223.478 305.723 224.581 305.926 226.108C306.128 227.635 305.024 229.076 303.497 229.279Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.176 179.691C314.539 179.775 314.09 179.317 314.022 178.808C313.938 178.172 314.396 177.722 314.905 177.655C315.542 177.57 315.991 178.028 316.059 178.537C316.143 179.174 315.685 179.623 315.176 179.691Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 282.284C229.982 282.419 228.972 281.647 228.837 280.629C228.702 279.611 229.475 278.602 230.493 278.466C231.511 278.331 232.521 279.104 232.656 280.121C232.791 281.139 232.018 282.148 231 282.284Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.906 337.16C279.506 337.346 278.081 336.37 277.878 334.843C277.692 333.443 278.669 332.019 280.197 331.816C281.597 331.63 283.022 332.606 283.225 334.133C283.427 335.66 282.307 336.974 280.906 337.16Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.008 275.992C213.481 276.195 212.039 275.091 211.836 273.565C211.633 272.038 212.737 270.596 214.265 270.393C215.792 270.191 217.234 271.294 217.437 272.821C217.64 274.348 216.536 275.789 215.008 275.992Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.235 243.125C236.835 243.311 235.537 242.318 235.351 240.918C235.165 239.519 236.159 238.221 237.559 238.035C238.959 237.849 240.257 238.842 240.443 240.242C240.501 241.659 239.635 242.939 238.235 243.125Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.118 197.494C256.954 197.781 254.936 196.237 254.649 194.073C254.361 191.91 255.907 189.892 258.071 189.605C260.235 189.318 262.253 190.862 262.541 193.025C262.955 195.171 261.41 197.189 259.118 197.494Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.971 216.612C315.952 216.747 314.943 215.975 314.808 214.957C314.673 213.939 315.445 212.93 316.464 212.795C317.482 212.659 318.491 213.432 318.627 214.45C318.762 215.467 317.989 216.477 316.971 216.612Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.832 247.67C326.431 247.856 325.134 246.863 324.948 245.463C324.762 244.064 325.755 242.766 327.156 242.58C328.556 242.394 329.854 243.387 330.039 244.787C330.225 246.187 329.232 247.484 327.832 247.67Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.238 245.527C370.583 245.747 368.997 244.533 368.777 242.879C368.557 241.225 369.772 239.639 371.427 239.419C373.081 239.2 374.667 240.413 374.887 242.067C375.107 243.721 373.893 245.307 372.238 245.527Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.98 339.096C356.579 339.282 355.282 338.289 355.096 336.889C354.91 335.489 355.903 334.192 357.304 334.006C358.704 333.82 360.002 334.813 360.188 336.213C360.373 337.612 359.38 338.91 357.98 339.096Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.982 357.729C321.218 357.831 320.497 357.279 320.396 356.516C320.294 355.752 320.846 355.032 321.61 354.93C322.374 354.829 323.095 355.38 323.196 356.144C323.297 356.907 322.746 357.628 321.982 357.729Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.82 324.18C292.42 324.366 291.122 323.373 290.936 321.973C290.751 320.573 291.744 319.276 293.144 319.09C294.545 318.904 295.842 319.897 296.028 321.297C296.214 322.696 295.22 323.994 293.82 324.18Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.728 382.742C168.455 382.911 167.301 382.029 167.132 380.756C166.963 379.484 167.847 378.331 169.12 378.162C170.392 377.993 171.546 378.875 171.715 380.148C171.867 381.293 171.001 382.573 169.728 382.742Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.572 356.03C107.535 356.301 105.788 354.85 105.535 352.941C105.264 350.905 106.716 349.159 108.626 348.905C110.662 348.635 112.41 350.086 112.663 351.994C112.916 353.903 111.609 355.76 109.572 356.03Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.797 315.432C120.27 315.635 118.828 314.532 118.625 313.005C118.422 311.478 119.526 310.037 121.054 309.834C122.581 309.631 124.023 310.734 124.226 312.261C124.556 313.771 123.452 315.213 121.797 315.432Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2648 511.797L106.607 519.869L106.692 503.932L94.2648 511.797Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94598 584.727L22.4451 589.535L18.2284 573.392L7.94598 584.727Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3734 542.747L86.7312 545.906L84.0556 535.515L77.3734 542.747Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.445 529.968L147.903 532.474L145.769 524.211L140.445 529.968Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2578 554.283C79.9126 554.063 81.4987 555.277 81.7184 556.931C81.9381 558.585 80.7237 560.17 79.0689 560.39C77.4141 560.61 75.828 559.396 75.6083 557.742C75.3717 555.961 76.4757 554.519 78.2578 554.283Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.378 512.802C128.032 512.582 129.619 513.796 129.838 515.45C130.058 517.104 128.844 518.69 127.189 518.91C125.534 519.129 123.948 517.916 123.728 516.262C123.508 514.608 124.595 513.039 126.378 512.802Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.285 544.791C168.94 544.571 170.526 545.784 170.746 547.438C170.966 549.093 169.751 550.678 168.096 550.898C166.442 551.118 164.855 549.904 164.636 548.25C164.416 546.596 165.63 545.01 167.285 544.791Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3258 511.888C54.3442 511.753 55.3535 512.525 55.4887 513.543C55.6239 514.561 54.8511 515.57 53.8328 515.706C52.8144 515.841 51.8051 515.068 51.6699 514.051C51.5347 513.033 52.1802 512.041 53.3258 511.888Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8066 662.289C13.8249 662.153 14.8343 662.926 14.9695 663.944C15.1047 664.962 14.3319 665.971 13.3136 666.106C12.2952 666.241 11.2859 665.469 11.1507 664.451C11.0155 663.433 11.7882 662.424 12.8066 662.289Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07301 631.215C3.47325 631.029 4.77099 632.022 4.95688 633.422C5.14277 634.821 4.14921 636.119 2.74898 636.305C1.34874 636.491 0.0510021 635.498 -0.134887 634.098C-0.320776 632.698 0.672779 631.401 2.07301 631.215Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79549 521.172C8.55925 521.071 9.28017 521.623 9.38157 522.386C9.48296 523.149 8.93102 523.87 8.16727 523.972C7.40351 524.073 6.68254 523.521 6.58115 522.758C6.47975 521.994 7.03173 521.274 7.79549 521.172Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9569 554.723C37.3572 554.537 38.6549 555.53 38.8408 556.93C39.0267 558.329 38.0331 559.626 36.6329 559.812C35.2327 559.998 33.9349 559.005 33.749 557.606C33.5632 556.206 34.684 554.892 35.9569 554.723Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.066 496.287C161.339 496.118 162.493 497 162.662 498.273C162.831 499.545 161.948 500.698 160.675 500.867C159.402 501.036 158.248 500.154 158.079 498.881C157.91 497.609 158.793 496.456 160.066 496.287Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.465 529.354C209.501 529.084 211.249 530.535 211.502 532.444C211.773 534.479 210.321 536.226 208.411 536.48C206.374 536.75 204.627 535.299 204.374 533.39C203.993 531.499 205.428 529.625 207.465 529.354Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.58817 511.811L3.55193 522.383L8.354 508.797L-4.58817 511.811Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.989 486.343L167.999 483.838L158.077 473.503L154.989 486.343Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.3027 400.198L-5.51528 411.196L-1.84875 394.912L-16.3027 400.198Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.885 415.272L130.401 420.207L126.185 404.063L115.885 415.272Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.332 478.403L125.903 481.919L122.914 470.145L115.332 478.403Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2301 448.833L32.3106 460.944L34.4608 440.07L17.2301 448.833Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.198 431.069L166.466 418.653L163.79 439.466L181.198 431.069Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5188 432.158C39.8284 431.718 42.8565 434.035 43.2958 437.343C43.7352 440.652 41.4169 443.679 38.1073 444.118C34.7976 444.558 31.7696 442.241 31.3302 438.933C30.7636 435.641 33.2092 432.597 36.5188 432.158Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2493 376.397L82.0069 377.69L77.4896 368.061L72.2493 376.397Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7062 392.198L97.9493 396.289L98.0303 388.121L91.7062 392.198Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2757 361.305L62.6166 364.338L59.958 354.073L53.2757 361.305Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7513 377.64L75.4273 383.742L76.6212 373.225L67.7513 377.64Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1601 372.841C55.8149 372.622 57.401 373.835 57.6207 375.489C57.8404 377.143 56.6261 378.729 54.9713 378.949C53.3164 379.168 51.7303 377.955 51.5106 376.301C51.274 374.519 52.378 373.078 54.1601 372.841Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.28 331.361C103.935 331.141 105.521 332.355 105.74 334.009C105.96 335.663 104.746 337.248 103.091 337.468C101.436 337.688 99.8501 336.474 99.6304 334.82C99.4107 333.166 100.498 331.598 102.28 331.361Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.184 402.061C146.348 401.774 148.367 403.318 148.654 405.481C148.941 407.645 147.396 409.663 145.232 409.95C143.068 410.237 141.049 408.693 140.762 406.53C140.602 404.35 142.147 402.332 144.184 402.061Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4539 466.139C101.618 465.852 103.637 467.397 103.924 469.56C104.211 471.723 102.666 473.741 100.502 474.028C98.3377 474.315 96.319 472.771 96.0317 470.608C95.7445 468.445 97.29 466.427 99.4539 466.139Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.866 457.083C200.03 456.795 202.049 458.34 202.336 460.503C202.623 462.666 201.078 464.684 198.914 464.971C196.75 465.259 194.731 463.714 194.444 461.551C194.14 459.261 195.702 457.37 197.866 457.083Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2282 330.447C30.2465 330.312 31.2559 331.084 31.3911 332.102C31.5262 333.12 30.7535 334.129 29.7351 334.264C28.7168 334.399 27.7074 333.627 27.5722 332.609C27.437 331.591 28.0825 330.599 29.2282 330.447Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5309 502.547C51.9311 502.361 53.2289 503.354 53.4148 504.754C53.6006 506.153 52.6071 507.451 51.2069 507.637C49.8066 507.823 48.5089 506.83 48.323 505.43C48.1202 503.903 49.1307 502.733 50.5309 502.547Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18268 468.182C3.7102 467.98 5.15214 469.083 5.35493 470.61C5.55771 472.137 4.45375 473.578 2.92623 473.781C1.39871 473.984 -0.0431896 472.881 -0.245975 471.354C-0.44876 469.827 0.655161 468.385 2.18268 468.182Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6965 415.304C75.7148 415.169 76.7241 415.941 76.8593 416.959C76.9945 417.977 76.2218 418.986 75.2034 419.121C74.1851 419.257 73.1757 418.484 73.0406 417.467C72.8885 416.321 73.6781 415.44 74.6965 415.304Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7732 360.3C26.1734 360.114 27.5984 361.09 27.8012 362.617C27.9871 364.017 27.0105 365.441 25.4829 365.644C24.0827 365.83 22.6577 364.854 22.455 363.327C22.3795 361.784 23.373 360.486 24.7732 360.3Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6882 421.597C92.2157 421.394 93.6576 422.497 93.8604 424.024C94.0632 425.551 92.9592 426.992 91.4317 427.195C89.9042 427.398 88.4623 426.295 88.2595 424.768C88.0398 423.114 89.1607 421.799 90.6882 421.597Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5719 454.319C68.9721 454.133 70.2698 455.126 70.4557 456.525C70.6416 457.925 69.648 459.222 68.2478 459.408C66.8476 459.594 65.5499 458.601 65.364 457.201C65.1781 455.802 66.1716 454.505 67.5719 454.319Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5611 499.967C48.725 499.68 50.7437 501.225 51.031 503.388C51.3183 505.551 49.7728 507.569 47.6088 507.856C45.4448 508.144 43.4262 506.599 43.1389 504.436C42.7243 502.29 44.3971 500.255 46.5611 499.967Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8593 373.281C13.2595 373.096 14.5572 374.089 14.7431 375.488C14.929 376.888 13.9355 378.185 12.5352 378.371C11.135 378.557 9.83728 377.564 9.6514 376.164C9.5928 374.748 10.5864 373.451 11.8593 373.281Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.882 382.028C185.41 381.825 186.852 382.929 187.055 384.455C187.257 385.982 186.153 387.424 184.626 387.627C183.098 387.83 181.656 386.726 181.454 385.199C181.251 383.672 182.355 382.231 183.882 382.028Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5009 126.508L20.8595 139.664L32.0996 130.661L19.5009 126.508Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.53792 167.096C0.723807 168.495 -0.252855 169.92 -1.78038 170.123C-3.18061 170.309 -4.6056 169.333 -4.80838 167.806C-4.99427 166.406 -4.01765 164.982 -2.49013 164.779C-0.962605 164.576 0.335135 165.569 0.53792 167.096Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46566 89.9256C2.65155 91.3252 1.658 92.6225 0.25777 92.8085C-1.14246 92.9945 -2.44019 92.0015 -2.62607 90.6019C-2.81196 89.2022 -1.81841 87.9049 -0.418181 87.719C1.12624 87.6433 2.27977 88.526 2.46566 89.9256Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1024 362.396C5.27139 363.668 4.38824 364.821 3.11531 364.99C1.84238 365.159 0.688822 364.277 0.519834 363.004C0.350846 361.732 1.23402 360.579 2.50696 360.41C3.65259 360.258 4.93341 361.123 5.1024 362.396Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5218 99.6232L40.8804 118.749L59.9101 109.877L43.5218 99.6232Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4345 137.677L4.23038 150.031L20.3189 150.225L12.4345 137.677Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5481 67.2874L59.3012 79.2825L79.2469 86.0857L74.5481 67.2874Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.996 186.574L161.372 199.858L172.595 190.728L159.996 186.574Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 357.208L17.4275 370.34L27.8789 360.276L14.9062 357.208Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.124 186.106L90.2475 196.873L106.41 200.553L101.124 186.106Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8712 317.695L19.3522 328.262L31.1319 325.273L22.8712 317.695Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.049 90.7574L28.9147 105.706L49.8133 107.98L41.049 90.7574Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4653 219.63L40.3478 234.706L61.2296 236.853L52.4653 219.63Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2172 383.528L82.7672 368.783L61.9451 366.111L70.2172 383.528Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5766 63.9845C51.016 67.2927 48.6977 70.3198 45.3881 70.7593C42.0784 71.1989 39.0504 68.8819 38.6111 65.5737C38.1717 62.2655 40.49 59.2385 43.7996 58.799C46.965 58.2491 50.1204 60.5491 50.5766 63.9845Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.908 158.451C132.347 161.759 130.029 164.786 126.719 165.226C123.41 165.665 120.382 163.349 119.942 160.04C119.503 156.732 121.821 153.705 125.131 153.266C128.296 152.716 131.469 155.143 131.908 158.451Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1454 238.91C69.5848 242.218 67.2665 245.245 63.9568 245.685C60.6472 246.124 57.6192 243.807 57.1798 240.499C56.7405 237.191 59.0587 234.164 62.3683 233.725C65.6611 233.158 68.706 235.602 69.1454 238.91Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.053 274.601L123.631 284.372L133.392 279.838L125.053 274.601Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.115 294.069L105.021 300.31L113.193 300.39L109.115 294.069Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.809 270.106L117.576 277.797L128.208 278.845L123.809 270.106Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55 335.768L123.444 343.442L133.949 344.507L129.55 335.768Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.611 256.519C128.83 258.173 127.616 259.758 125.961 259.978C124.306 260.198 122.72 258.984 122.501 257.33C122.281 255.676 123.495 254.091 125.15 253.871C126.788 253.524 128.374 254.737 128.611 256.519Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2419 346.526C99.5292 348.689 97.9837 350.707 95.8197 350.995C93.6557 351.282 91.637 349.738 91.3497 347.575C91.0624 345.412 92.608 343.394 94.772 343.106C97.0802 342.929 98.9547 344.363 99.2419 346.526Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1418 301.821C35.4291 303.984 33.8836 306.002 31.7197 306.29C29.5557 306.577 27.537 305.033 27.2497 302.869C26.9624 300.706 28.508 298.688 30.6719 298.401C32.9632 298.097 34.8546 299.658 35.1418 301.821Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3183 400.175C44.6056 402.338 43.0601 404.356 40.8961 404.643C38.7321 404.931 36.7134 403.386 36.4261 401.223C36.1388 399.06 37.6844 397.042 39.8484 396.755C42.0124 396.467 44.031 398.012 44.3183 400.175Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7699 171.022C18.0234 172.93 16.7156 174.787 14.6789 175.058C12.7695 175.311 10.9119 174.004 10.6415 171.968C10.3881 170.06 11.6959 168.203 13.7326 167.932C15.7693 167.662 17.5164 169.113 17.7699 171.022Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1452 119.914C69.2804 120.932 68.5076 121.941 67.4893 122.077C66.4709 122.212 65.4616 121.44 65.3264 120.422C65.1912 119.404 65.964 118.395 66.9823 118.259C68.128 118.107 69.01 118.897 69.1452 119.914Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.715 104.212C135.951 105.993 134.72 107.452 133.065 107.672C131.283 107.908 129.824 106.678 129.605 105.024C129.368 103.242 130.599 101.784 132.254 101.564C133.892 101.217 135.478 102.431 135.715 104.212Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.268 89.5043C98.4708 91.0312 97.3669 92.4726 95.8393 92.6755C94.3118 92.8784 92.8699 91.775 92.6671 90.2482C92.4643 88.7213 93.5683 87.2799 95.0958 87.077C96.6233 86.8741 98.0652 87.9775 98.268 89.5043Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.883 231.483C171.018 232.501 170.246 233.51 169.227 233.645C168.209 233.78 167.2 233.008 167.064 231.99C166.929 230.972 167.702 229.963 168.72 229.828C169.739 229.693 170.748 230.465 170.883 231.483Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1799 160.787C81.3151 161.805 80.6528 162.67 79.6344 162.805C78.6161 162.94 77.7509 162.278 77.6157 161.261C77.4806 160.243 78.1429 159.378 79.1613 159.243C80.1796 159.107 81.0616 159.897 81.1799 160.787Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1097 204.592C33.3125 206.119 32.2086 207.561 30.6811 207.763C29.1535 207.966 27.7116 206.863 27.5088 205.336C27.306 203.809 28.41 202.368 29.9375 202.165C31.465 201.962 32.907 203.065 33.1097 204.592Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1288 277.053C86.264 278.071 85.4912 279.08 84.4729 279.215C83.4546 279.351 82.4452 278.578 82.31 277.56C82.1748 276.542 82.9476 275.533 83.9659 275.398C84.9843 275.263 85.9936 276.035 86.1288 277.053Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.033 227.16C141.219 228.56 140.243 229.984 138.715 230.187C137.315 230.373 135.89 229.397 135.687 227.87C135.501 226.471 136.478 225.046 138.005 224.843C139.533 224.64 140.847 225.761 141.033 227.16Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.797 74.1676C134.102 76.4579 132.446 78.62 130.154 78.9244C127.863 79.2287 125.7 77.5737 125.396 75.2834C125.092 72.9931 126.748 70.831 129.039 70.5267C131.474 70.3327 133.493 71.8773 133.797 74.1676Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.726 129.266C115.878 130.411 115.105 131.42 113.959 131.573C112.814 131.725 111.804 130.952 111.652 129.807C111.5 128.662 112.273 127.653 113.419 127.501C114.564 127.349 115.574 128.121 115.726 129.266Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.144 101.709C132.313 102.981 131.447 104.261 130.046 104.447C128.774 104.616 127.493 103.751 127.307 102.351C127.138 101.079 128.004 99.7982 129.404 99.6122C130.821 99.5535 131.975 100.436 132.144 101.709Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03121 67.5763C4.28469 69.4849 2.97687 71.3419 0.940184 71.6124C-0.969213 71.866 -2.82679 70.5589 -3.09717 68.5231C-3.35066 66.6145 -2.04284 64.7575 -0.00614797 64.487C2.03054 64.2165 3.77773 65.6678 4.03121 67.5763Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8319 293.038C80.0346 294.564 78.9307 296.006 77.4032 296.209C75.8757 296.412 74.4337 295.308 74.231 293.781C74.0282 292.255 75.1321 290.813 76.6596 290.61C78.1871 290.407 79.6291 291.511 79.8319 293.038Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9719 269.953C47.1578 271.353 46.1643 272.65 44.7641 272.836C43.3638 273.022 42.0661 272.029 41.8802 270.629C41.6943 269.23 42.6879 267.932 44.0881 267.746C45.4883 267.56 46.7861 268.553 46.9719 269.953Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30609 248.955C1.59337 251.118 0.0478293 253.136 -2.11616 253.423C-4.28015 253.711 -6.29885 252.166 -6.58613 250.003C-6.87341 247.84 -5.32787 245.822 -3.16388 245.534C-1.01679 245.12 1.00191 246.664 1.30609 248.955Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4399 191.125C20.5751 192.143 19.8024 193.152 18.784 193.288C17.7657 193.423 16.7564 192.65 16.6212 191.633C16.486 190.615 17.2587 189.606 18.2771 189.47C19.4227 189.318 20.3048 190.107 20.4399 191.125Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5118 180.265C51.6977 181.665 50.7041 182.962 49.3039 183.148C47.9037 183.334 46.606 182.341 46.4201 180.942C46.2342 179.542 47.2277 178.245 48.628 178.059C50.0451 178 51.3259 178.866 51.5118 180.265Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3732 135.878C49.5929 137.532 48.3786 139.118 46.7238 139.337C45.069 139.557 43.4829 138.344 43.2632 136.689C43.0435 135.035 44.2578 133.45 45.9126 133.23C47.5674 133.01 49.1535 134.224 49.3732 135.878Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.978 150.119C143.164 151.519 142.17 152.816 140.77 153.002C139.37 153.188 138.072 152.195 137.886 150.795C137.7 149.396 138.694 148.098 140.094 147.912C141.494 147.726 142.792 148.719 142.978 150.119Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.617 186.101C161.719 186.864 161.167 187.585 160.403 187.686C159.639 187.788 158.918 187.236 158.817 186.473C158.715 185.709 159.267 184.989 160.031 184.887C160.795 184.786 161.516 185.337 161.617 186.101Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.049 214.254C128.235 215.653 127.242 216.951 125.841 217.137C124.441 217.323 123.143 216.33 122.958 214.93C122.772 213.53 123.765 212.233 125.165 212.047C126.693 211.844 127.863 212.854 128.049 214.254Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.893 398.422C160.163 400.458 158.711 402.204 156.802 402.458C154.765 402.729 153.018 401.277 152.764 399.369C152.494 397.333 153.946 395.586 155.855 395.333C157.892 395.062 159.639 396.513 159.893 398.422Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.279 386.206C119.482 387.733 118.378 389.175 116.851 389.378C115.323 389.58 113.881 388.477 113.678 386.95C113.476 385.423 114.58 383.982 116.107 383.779C117.618 383.449 119.06 384.552 119.279 386.206Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.695 411.747L334.771 399.409L318.827 399.326L326.695 411.747Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.928 527.767C354.488 524.458 356.807 521.431 360.116 520.992C363.426 520.552 366.454 522.869 366.893 526.177C367.333 529.486 365.014 532.513 361.705 532.952C358.412 533.519 355.367 531.075 354.928 527.767Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.782 411.617L363.078 401.863L353.444 406.38L361.782 411.617Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.594 392.167L381.814 385.909L373.643 385.829L377.594 392.167Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.684 430.585L349.846 421.23L339.45 423.906L346.684 430.585Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.907 367.54L336.414 360.086L328.275 362.203L333.907 367.54Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.027 416.114L369.26 408.423L358.628 407.375L363.027 416.114Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.159 350.469L363.391 342.779L352.76 341.731L357.159 350.469Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.225 429.699C358.005 428.045 359.22 426.46 360.875 426.24C362.529 426.02 364.116 427.234 364.335 428.888C364.555 430.542 363.341 432.127 361.686 432.347C360.031 432.567 358.462 431.48 358.225 429.699Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.733 381.605C316.513 379.951 317.727 378.366 319.382 378.146C321.037 377.926 322.623 379.14 322.843 380.794C323.062 382.448 321.848 384.034 320.193 384.253C318.538 384.473 316.969 383.387 316.733 381.605Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.738 340.711C348.518 339.057 349.733 337.471 351.387 337.251C353.042 337.032 354.628 338.245 354.848 339.899C355.068 341.554 353.853 343.139 352.199 343.359C350.544 343.579 348.958 342.365 348.738 340.711Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.187 396.575C313.747 393.267 316.066 390.24 319.375 389.8C322.685 389.361 325.713 391.678 326.152 394.986C326.592 398.294 324.274 401.321 320.964 401.761C317.654 402.2 314.626 399.883 314.187 396.575Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.121 582.008C350.884 580.226 352.116 578.768 353.77 578.548C355.553 578.312 357.011 579.542 357.231 581.196C357.468 582.978 356.236 584.436 354.582 584.656C352.944 585.003 351.358 583.789 351.121 582.008Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.825 454.754C315.69 453.736 316.463 452.727 317.481 452.591C318.5 452.456 319.509 453.229 319.644 454.246C319.779 455.264 319.007 456.273 317.988 456.409C316.953 456.417 315.961 455.772 315.825 454.754Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.651 543.249C304.465 541.85 305.441 540.425 306.969 540.222C308.369 540.036 309.794 541.012 309.997 542.539C310.183 543.939 309.206 545.363 307.679 545.566C306.278 545.752 304.853 544.776 304.651 543.249Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.911 612.069C352.607 609.778 354.263 607.616 356.554 607.312C358.846 607.007 361.008 608.662 361.313 610.953C361.617 613.243 359.961 615.405 357.67 615.71C355.361 615.887 353.215 614.359 352.911 612.069Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.11 556.952C370.958 555.807 371.731 554.798 372.877 554.645C374.022 554.493 375.032 555.266 375.184 556.411C375.336 557.556 374.563 558.565 373.417 558.717C372.272 558.869 371.262 558.097 371.11 556.952Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.565 584.529C354.396 583.256 355.262 581.976 356.662 581.79C357.935 581.621 359.216 582.487 359.402 583.886C359.571 585.159 358.704 586.439 357.304 586.625C355.887 586.684 354.734 585.801 354.565 584.529Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.091 500.137C324.99 499.373 325.542 498.653 326.306 498.551C327.069 498.45 327.79 499.001 327.892 499.765C327.993 500.528 327.441 501.249 326.677 501.35C325.914 501.452 325.193 500.9 325.091 500.137Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.659 471.983C358.473 470.583 359.467 469.286 360.867 469.1C362.267 468.914 363.565 469.907 363.751 471.306C363.937 472.706 362.943 474.003 361.543 474.189C360.126 474.248 358.845 473.382 358.659 471.983Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.213 347.932C300.044 346.66 300.928 345.507 302.2 345.338C303.473 345.168 304.627 346.051 304.796 347.324C304.965 348.596 304.082 349.749 302.809 349.918C301.536 350.087 300.382 349.205 300.213 347.932Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3 300.55C333.03 298.515 334.482 296.768 336.391 296.514C338.428 296.244 340.175 297.695 340.428 299.604C340.699 301.639 339.247 303.386 337.337 303.64C335.445 304.021 333.57 302.586 333.3 300.55Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.002 434.439L152.269 420.021L137.212 425.647L149.002 434.439Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32 523.754L143.944 510.471L132.594 519.618L145.32 523.754Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.852 512.499L326.302 504.378L312.711 499.579L315.852 512.499Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.265 353.008L287.761 340.004L277.42 349.923L290.265 353.008Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.065 524.238L215.068 513.454L198.778 509.791L204.065 524.238Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.176 392.231L224.098 377.594L207.947 381.81L219.176 392.231Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.317 392.649L285.836 382.082L274.057 385.071L282.317 392.649Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.723 490.713L264.841 475.638L244.086 473.474L252.723 490.713Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.408 551.876C172.968 548.568 175.287 545.541 178.596 545.101C181.906 544.662 184.934 546.979 185.373 550.287C185.813 553.595 183.494 556.622 180.185 557.062C176.892 557.628 173.847 555.184 173.408 551.876Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.043 471.435C235.604 468.126 237.922 465.099 241.232 464.66C244.541 464.22 247.569 466.537 248.009 469.845C248.448 473.154 246.13 476.181 242.82 476.62C239.655 477.17 236.482 474.743 236.043 471.435Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.262 435.726L181.558 425.973L171.924 430.489L180.262 435.726Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2133 603.162L57.5086 593.408L47.8749 597.925L56.2133 603.162Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.677 566.43L269.972 556.676L260.338 561.192L268.677 566.43Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.074 416.276L200.294 410.018L192.123 409.938L196.074 416.276Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.164 454.694L168.326 445.34L157.93 448.015L165.164 454.694Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.571 587.145L231.733 577.791L221.337 580.467L228.571 587.145Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.387 391.65L154.894 384.195L146.755 386.312L152.387 391.65Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.507 440.221L187.74 432.531L177.108 431.483L181.507 440.221Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.705 453.809C176.485 452.154 177.7 450.569 179.355 450.349C181.009 450.129 182.595 451.343 182.815 452.997C183.035 454.651 181.821 456.237 180.166 456.457C178.511 456.676 176.942 455.59 176.705 453.809Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.213 405.713C134.993 404.059 136.207 402.473 137.862 402.253C139.517 402.034 141.103 403.247 141.323 404.901C141.542 406.555 140.328 408.141 138.673 408.361C137.018 408.581 135.449 407.494 135.213 405.713Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.901 424.668C130.35 421.767 131.404 418.001 134.307 416.45C137.21 414.899 140.977 415.953 142.528 418.854C144.079 421.756 143.025 425.522 140.122 427.072C137.236 428.751 133.596 427.68 131.901 424.668Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.947 363.819C205.659 361.656 207.205 359.638 209.369 359.35C211.533 359.063 213.552 360.607 213.839 362.771C214.126 364.934 212.581 366.952 210.417 367.239C208.236 367.399 206.234 365.982 205.947 363.819Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.047 408.522C269.759 406.359 271.305 404.341 273.469 404.053C275.633 403.766 277.652 405.311 277.939 407.474C278.226 409.637 276.681 411.655 274.517 411.942C272.353 412.23 270.334 410.685 270.047 408.522Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.998 310.153C260.71 307.99 262.256 305.972 264.42 305.684C266.584 305.397 268.602 306.941 268.89 309.105C269.177 311.268 267.632 313.286 265.468 313.573C263.176 313.877 261.285 312.316 260.998 310.153Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.419 539.324C287.165 537.415 288.473 535.558 290.51 535.288C292.419 535.034 294.277 536.341 294.547 538.377C294.801 540.286 293.493 542.143 291.456 542.413C289.419 542.684 287.672 541.233 287.419 539.324Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.305 478.861C134.17 477.843 134.943 476.834 135.961 476.699C136.98 476.564 137.989 477.336 138.124 478.354C138.259 479.372 137.487 480.381 136.468 480.516C135.433 480.524 134.441 479.879 134.305 478.861Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.464 457.42C306.279 456.021 307.272 454.723 308.672 454.537C310.073 454.351 311.37 455.344 311.556 456.744C311.742 458.144 310.748 459.441 309.348 459.627C307.948 459.813 306.65 458.82 306.464 457.42Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.009 549.557C223.873 548.54 224.536 547.675 225.554 547.539C226.572 547.404 227.438 548.066 227.573 549.084C227.708 550.102 227.046 550.967 226.027 551.102C225.009 551.237 224.127 550.448 224.009 549.557Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.079 505.752C271.876 504.225 272.98 502.784 274.507 502.581C276.035 502.378 277.477 503.481 277.68 505.008C277.882 506.535 276.779 507.976 275.251 508.179C273.724 508.382 272.282 507.279 272.079 505.752Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67 517.294C321.586 516.658 322.044 516.209 322.554 516.141C323.19 516.057 323.639 516.515 323.707 517.024C323.792 517.66 323.333 518.109 322.824 518.177C322.332 518.372 321.755 517.93 321.67 517.294Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.187 433.275C219.052 432.257 219.825 431.248 220.843 431.113C221.861 430.978 222.871 431.75 223.006 432.768C223.141 433.786 222.368 434.795 221.35 434.93C220.332 435.065 219.322 434.293 219.187 433.275Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.155 483.183C163.969 481.783 164.946 480.359 166.473 480.156C168.001 479.953 169.299 480.946 169.501 482.473C169.687 483.872 168.711 485.297 167.183 485.5C165.656 485.703 164.341 484.582 164.155 483.183Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.437 636.008C337.302 634.99 338.075 633.981 339.093 633.845C340.111 633.71 341.121 634.482 341.256 635.5C341.391 636.518 340.618 637.527 339.6 637.663C338.581 637.798 337.572 637.025 337.437 636.008Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.484 417.289C225.281 415.762 226.385 414.321 227.913 414.118C229.44 413.915 230.882 415.018 231.085 416.545C231.288 418.072 230.184 419.514 228.656 419.716C227.129 419.919 225.687 418.816 225.484 417.289Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.217 440.393C258.031 438.993 259.024 437.696 260.425 437.51C261.825 437.324 263.122 438.317 263.308 439.717C263.494 441.116 262.501 442.414 261.1 442.6C259.7 442.785 258.403 441.793 258.217 440.393Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.909 559.541C117.723 558.142 118.716 556.844 120.117 556.658C121.517 556.472 122.815 557.465 123 558.865C123.186 560.265 122.193 561.562 120.793 561.748C119.392 561.934 118.095 560.941 117.909 559.541Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.01 461.371C303.722 459.208 305.268 457.19 307.432 456.903C309.596 456.616 311.615 458.16 311.902 460.323C312.189 462.486 310.644 464.504 308.48 464.792C306.333 465.206 304.314 463.662 304.01 461.371Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.749 519.22C284.613 518.203 285.386 517.194 286.404 517.058C287.423 516.923 288.432 517.695 288.567 518.713C288.703 519.731 287.93 520.74 286.911 520.875C285.893 521.011 284.884 520.238 284.749 519.22Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.677 530.078C253.491 528.679 254.484 527.382 255.885 527.196C257.285 527.01 258.583 528.003 258.769 529.402C258.954 530.802 257.961 532.099 256.561 532.285C255.143 532.344 253.846 531.351 253.677 530.078Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.571 524.244C143.47 523.481 144.022 522.76 144.786 522.659C145.549 522.557 146.27 523.109 146.372 523.872C146.473 524.636 145.921 525.356 145.157 525.458C144.394 525.559 143.673 525.008 143.571 524.244Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.139 496.09C176.953 494.691 177.947 493.393 179.347 493.207C180.747 493.021 182.045 494.014 182.231 495.414C182.417 496.813 181.423 498.111 180.023 498.297C178.606 498.355 177.325 497.49 177.139 496.09Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.693 372.04C118.524 370.767 119.407 369.614 120.68 369.445C121.953 369.276 123.107 370.159 123.276 371.431C123.445 372.703 122.562 373.856 121.289 374.026C120.016 374.195 118.862 373.312 118.693 372.04Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.296 311.923C145.025 309.888 146.477 308.141 148.387 307.887C150.424 307.617 152.171 309.068 152.424 310.977C152.695 313.013 151.243 314.759 149.333 315.013C147.424 315.266 145.549 313.832 145.296 311.923Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.752 73.5082L304.049 71.3848L303.547 79.3268L337.251 81.4502L337.752 73.5082Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6569 306.444L87.9521 299.4L58.0587 315.112L61.7634 322.156L91.6569 306.444Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.746 267.844L316.444 260.227L284.115 269.993L286.418 277.61L318.746 267.844Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.148 126.004L84.0828 98.1426L77.5116 102.636L96.5768 130.497L103.148 126.004Z",
    fill: "#FB896E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6802_56151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 636,
    height: 640,
    fill: "white",
    transform: "translate(412.429) rotate(82.4347)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnfettiMobil);
export default __webpack_public_path__ + "static/media/сonfetti-mobil.58bc1a6562e4467b8a722a9c3c4f55b4.svg";
export { ForwardRef as ReactComponent };